import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsFilter } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { ProviderScope } from '~/types/Provider';

type ProviderFiltersProps = {
  setSearch: (val: string) => void;
  selectedScopes: string[];
  setSelectedScopes: React.Dispatch<React.SetStateAction<string[]>>;
  uniqueScopes: ProviderScope[];
};

const ProviderFilters: React.FC<ProviderFiltersProps> = ({
  setSearch,
  selectedScopes,
  setSelectedScopes,
  uniqueScopes,
}) => {
  return (
    <div className="sticky top-14 md:top-20">
      <h3 className="mb-4 flex items-center gap-2 text-xl font-bold text-black">
        <FontAwesomeIcon icon={faBarsFilter} className="text-blue" />
        Aanbieders filteren
      </h3>
      <form className="space-y-5">
        <div className="form-control pb-5 border-b separator-border-color">
          <label htmlFor="filter-on-name" className="filter-label">
            Op naam
          </label>
          <input
            type="text"
            id="filter-on-name"
            className="form-input"
            onChange={({ target }) => setSearch(target.value)}
          />
        </div>

        {uniqueScopes.length > 0 && (
          <fieldset className="form-control">
            <legend className="filter-label">
              Op categorie
            </legend>
            {uniqueScopes.map(({ id, name, slug }, index) => (
              <div key={id} className="form-checkbox">
                <input
                  type="checkbox"
                  name="filters[]"
                  id={`filter-on-scope-${index}`}
                  value={slug}
                  className="form-checkbox__input"
                  checked={selectedScopes.includes(slug)}
                  onChange={({ target }) => {
                    if (target.checked) {
                      setSelectedScopes((prev) => [...prev, slug]);
                    } else {
                      setSelectedScopes((prev) => prev.filter(s => s !== slug));
                    }
                  }}
                />
                <label
                  htmlFor={`filter-on-scope-${index}`}
                  className="form-checkbox__label"
                >
                  <FontAwesomeIcon icon={faCheck as IconProp} className="form-checkbox__check" />
                  {name}
                </label>
              </div>
            ))}
          </fieldset>
        )}
      </form>
    </div>
  );
};

export default ProviderFilters;